'use client';
import cn from 'classnames';
import { SubscriptionProduct } from '@/types/Subscription';
import SlickCarousel from '@/components/common/SlickCarousel/SlickCarousel';
import PlanCarousel from '@/components/common/PlanCarousel/PlanCarousel';
import PlanCard from '@/components/common/PlanCard/PlanCard';
import PlanTierGroup from '@/components/common/PlanTierGroup/PlanTierGroup';
import Text from '@/components/common/Text/Text';

import './PlanCardList.style.scss';
import { useMemo, useState } from 'react';

type PlanCardListProps = {
  className?: string;
  data: SubscriptionProduct[];
};

function PlanCardList(props: PlanCardListProps) {
  const { className = '' } = props;

  const data = props.data;
  const [activeSlide, setActiveSlide] = useState(1);

  const singleItemTierPlans = data.filter((plan) => {
    return plan.allowed_borrowed_items === 1;
  });
  const multiItemTierPlans = data.filter((plan) => {
    return plan.allowed_borrowed_items > 1;
  });

  // This is used for the mobile carousel
  const planCards = useMemo(() => {
    return data.map((plan) => {
      return (
        <PlanCard
          key={plan.name}
          planData={plan}
        />
      );
    });
  }, [data]);

  return (
    <div className={cn('PlanCardList', className)}>
      {/* Show carousel on mobile only */}
      <Text
        variant='title-xxs-500-upper'
        className={cn('PlanCardList-tier-group-title mobile', {
          'multi-item-tier': activeSlide > 1
        })}
      >
        {activeSlide > 1 ? 'Multiple Item Tiers' : 'Single Item Tiers'}
      </Text>

      <SlickCarousel
        className='PlanCardList-carousel-mobile'
        slickSettings={{
          arrows: false,
          centerMode: true,
          centerPadding: '55px',
          initialSlide: 1, // start on classique
          swipeToSlide: true,
          variableWidth: true,
          beforeChange: (current, next) => {
            setActiveSlide(next);
          }
        }}
      >
        {planCards}
      </SlickCarousel>

      {/* Show this on md-up() only */}
      <PlanCarousel>
        <PlanTierGroup
          plans={singleItemTierPlans}
          title='Single Item Tiers'
        />

        <PlanTierGroup
          plans={multiItemTierPlans}
          title='Multiple Item Tiers'
          titleDarkBgColor={true}
        />
      </PlanCarousel>
    </div>
  );
}

export default PlanCardList;
